/* eslint-disable react-refresh/only-export-components */
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { lazy } from 'react';

const ExportRankings = lazy(
  () => import('@/modules/reports/export-rankings/ExportRankings'),
);
const UnsoldStock = lazy(
  () => import('@/modules/reports/unsold-stock/UnsoldStock'),
);
const ProfitLoss = lazy(
  () => import('@/modules/reports/profit-loss/ProfitLoss'),
);
const UrikakeMauke = lazy(
  () => import('@/modules/reports/urikake-mauke/UrikakeMauke'),
);

export const reportRoutes = [
  {
    path: 'profit-loss',
    element: withSuspense(ProfitLoss),
  },
  {
    path: 'unsold-stock',
    element: withSuspense(UnsoldStock),
  },
  {
    path: 'export-ranking',
    element: withSuspense(ExportRankings),
  },
  {
    path: 'urikake-maeuke',
    element: withSuspense(UrikakeMauke),
  },
];
